export default "__VITE_ASSET__sIlOKPHq__"